export const environment = {
  production: true,
  hideElttoUi: false,
  apiUrl: 'https://auth.uat2.mountainseedapp.com/api',
  elttoUrl: 'https://eltto.uat2.mountainseedapp.com/',
  miUrl: 'https://mi.uat2.mountainseedapp.com/',
  ngxs: {
    plugins: [],
  },
  gaId: 'G-N8S2M90J40',
};
